import { z } from 'zod';

// VERA commercial proposal PDF payload. The pricing calculator (web) does all
// the maths and i18n, then sends fully-resolved strings; the API is a pure
// pdf-lib layout engine with no business logic or copy of its own.

const KpiSchema = z.tuple([z.string(), z.string()]); // [value, label]

export const ProposalPdfSchema = z.object({
  lang: z.enum(['ES', 'EN']),
  ref: z.string().min(1),
  dateStr: z.string().min(1),
  validLine: z.string().min(1),
  confidential: z.string().min(1),
  forLbl: z.string().min(1),
  heroSub: z.string().min(1),
  client: z.object({
    name: z.string().min(1),
    contact: z.string().min(1),
    sector: z.string().min(1),
  }),
  hasRoi: z.boolean(),
  diag: z.string().min(1),
  deliverables: z.array(z.string().min(1)).min(1),
  sections: z.object({
    s01: z.string(),
    s02: z.string(),
    s03: z.string(),
    s04: z.string(),
    s05: z.string(),
    s06: z.string(),
    s07: z.string(),
    solTitle: z.string(),
    numTitle: z.string(),
    recTitle: z.string(),
    closeTitle: z.string(),
    closeBody: z.string(),
  }),
  invest: z.object({
    headers: z.tuple([z.string(), z.string(), z.string(), z.string()]),
    setupTitle: z.string(),
    setupRows: z.array(
      z.object({
        c: z.string(),
        base: z.string(),
        disc: z.string(),
        total: z.string(),
      }),
    ),
    monthlyTitle: z.string(),
    monthlyLabel: z.string(),
    monthlyValue: z.string(),
    disclaimer: z.string(),
  }),
  kpisTop: z.tuple([KpiSchema, KpiSchema, KpiSchema]),
  roi: z
    .object({
      kpis: z.tuple([KpiSchema, KpiSchema, KpiSchema]),
      projCols: z.array(z.string()),
      projRows: z.array(z.array(z.string())),
      steps: z.array(z.tuple([z.string(), z.string(), z.string()])),
    })
    .nullable(),
});

export type ProposalPdfData = z.infer<typeof ProposalPdfSchema>;
